"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const atoms_1 = require("../../atoms");
const hooks_1 = require("../../hooks");
function NotificationBadge({ className }) {
    const notifications = (0, hooks_1.useNotifications)() || [];
    const unreadNotifications = notifications.filter(notification => notification.status === bridge_schema_1.NotificationStatus.Unread);
    /*
     * Provide an empty JSX element to avoid render error
     */
    // eslint-disable-next-line react/jsx-no-useless-fragment
    if (!unreadNotifications.length)
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    return ((0, jsx_runtime_1.jsx)(atoms_1.CountBadge, { count: unreadNotifications.length, size: 20, className: className, "data-e2e": 'NotificationBadge_CountBadge' }));
}
exports.default = NotificationBadge;
